import React from "react";
import Paper from "material-ui/Paper";
import { Tabs, Tab } from "material-ui/Tabs";
import ServiceRequestList from "../../../../components/services/ServiceRequestList";

import { services as ROLES_CONFIG } from "../../../../config/roles";
import { store } from "../../../../stores/configureStore";
import { push } from "react-router-redux";

import DataService from "../../../../services/DataService";
var ds = DataService;

export default class ServiceRequests extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      role: this.props.authenticated ? this.props.authenticated.role : null,
      user: this.props.authenticated ? this.props.authenticated.user : null,
      accesible_services: this.props.authenticated
        ? this.props.authenticated.user.accessible_service
        : [],
      root_user: this.props.authenticated
        ? this.props.authenticated.user.root_user
        : false,
      all_services: [],
      selectedID:
        this.props && this.props.match && this.props.match.params
          ? this.props.match.params.name
          : "all",
    };
    //console.log("Hereasdasdsad2324234",this.state);
    // if (
    //   this.props.authenticated &&
    //   this.props.authenticated.role == "hotel_admin"
    // ) {
      // console.log("Hereasdasdsad2324234",this.state);
      this.getAllServices();
   // }
  }

  handleChange(e) {
    let item = e == "Food Order" ? "Food" : e;
    this.setState({ selectedID: item });
  }

  getAllServices() {
    ds.getAllServices(
      (data) => {
        if (this.state.selectedID == "all") {
          this.setState({
            selectedID: data[0].name,
          });
        }
        let services = [];
        if (this.state.root_user) {
          services = data;
        } else {
          data.map((elm) => {
            for (let i of this.state.accesible_services) {
              if (elm._id == i._id) {
                services.push(elm);
              }
            }
          });
        }
        this.setState({
          all_services: services,
        });
      },
      (err) => {}
    );
  }

  render() {
    return (
      <div id="content" style={{ width: "100%" }}>
        <Paper className="row">
          {ROLES_CONFIG.requests.indexOf(this.state.role) != -1 &&
          this.state.all_services &&
          this.state.all_services.length ? (
            <Tabs
              value={this.state.selectedID}
              className="tabs-container"
              scrollable
              scrollButtons="auto"
              onChange={(e) => this.handleChange(e)}
              style={{ width: "100%" }}
            >
              {this.state.all_services.map((service, index) => {
                return (
                  <Tab
                    label={service.name}
                    className="tab"
                    value={service.name}
                  >
                    <div
                      key={index}
                      className="col-sm-11 col-11 ml-3-2vw mb-1vw h-100 p-0 customShadow"
                      zDepth={3}
                      style={{
                        display:
                          this.state.selectedID == service.name
                            ? "block"
                            : "none",
                      }}
                    >
                      <ServiceRequestList
                        selectedID={this.state.selectedID}
                        service_ids={service._id}
                        service_name={service.name}
                        serviceChange={(e) => {
                          this.handleChange(e);
                        }}
                      />
                    </div>
                  </Tab>
                );
              })}
            </Tabs>
          ) : (
            ""
          )}
        </Paper>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./routes/app/routes/services/ServiceRequests.js